module.exports = __webpack_public_path__ + "img/500-camions-plateaux.7f48fb90.png";